const neutrals = {
    A10: '#FFFFFF',
    A20: '#F9F9F9',
    A30: '#E2E2E0',
    A40: '#A8A8A2',
    A50: '#6D6E65',
    A60: '#393832',
};

export default neutrals;
